import React from 'react';
import DashboardLayout from '../components/dashboard/DashboardLayout';
import DashboardBody from '../components/dashboard/DashboardBody';
import StaffDashboard from '../components/dashboard/StaffDashboard';
import { useAuth } from '../contexts/AuthContext';
import styled from 'styled-components';
import { theme } from '../theme';
import { Card, CardBody } from '../components/ui/Card';

const AccessDeniedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  text-align: center;
  padding: ${theme.spacing[8]};
`;

const AccessDeniedIcon = styled.div`
  font-size: 64px;
  margin-bottom: ${theme.spacing[4]};
  opacity: 0.5;
`;

const AccessDeniedTitle = styled.h2`
  font-size: ${theme.typography.fontSize['2xl']};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.light.text.primary};
  margin: 0 0 ${theme.spacing[2]} 0;
`;

const AccessDeniedText = styled.p`
  font-size: ${theme.typography.fontSize.base};
  color: ${theme.colors.light.text.secondary};
  margin: 0;
`;

const DashboardPage: React.FC = () => {
    const { companyData, staffData } = useAuth();

    // Determine if user is staff
    // If staffData exists, user is staff (companyData may exist for company logo/name)
    // If only companyData exists (no staffData), user is admin
    const isStaff = !!staffData;

    // All staff have dashboard access automatically
    // Admin/company owners always have access
    // If somehow no access, show denied message
    if (!companyData && !staffData) {
        return (
            <DashboardLayout>
                <Card>
                    <CardBody>
                        <AccessDeniedContainer>
                            <AccessDeniedIcon>🚫</AccessDeniedIcon>
                            <AccessDeniedTitle>Access Denied</AccessDeniedTitle>
                            <AccessDeniedText>
                                You don't have permission to access the dashboard. Please contact your administrator.
                            </AccessDeniedText>
                        </AccessDeniedContainer>
                    </CardBody>
                </Card>
            </DashboardLayout>
        );
    }

    return (
        <DashboardLayout>
            {isStaff ? <StaffDashboard /> : <DashboardBody />}
        </DashboardLayout>
    );
};

export default DashboardPage;







